import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ListSportSchedule from "./List";
import permissions from "app/permissions";
import { ACTIVITIES, ActivityServicePath, SPORTS } from "utils/constants";
import CreateSportSchedule from "./Create";
import EditSportSchedule from "./Edit";
import ShowSportSchedule from "./Show";
const { tenants } = require("utils/tenants");

export const resources = {
  isMenu: true,
  tenancies: [tenants.MGU],
  icon: <EmojiEventsIcon />,
  name: ActivityServicePath + ACTIVITIES + "/" + SPORTS,
  title: "Разписание спорт",
  list: <ListSportSchedule />,
  create: <CreateSportSchedule />,
  edit: <EditSportSchedule />,
  show: <ShowSportSchedule />,
  permission: permissions.canPreviewSportActivities,
};
